import { Button } from "@/components/ui/button";
import { Mic, Pause, Play, Square, RotateCcw, RefreshCw, ExternalLink } from "lucide-react";

export const RecordingControls = ({ recState, onStart, onPause, onResume, onStop, onRetry, onRestart, onOpenMeeting }) => (
  <div className="flex flex-wrap items-center justify-center gap-3">
    {recState === "idle" && (
      <Button
        data-testid="start-recording-btn"
        onClick={onStart}
        className="bg-terracotta hover:bg-[#9C7124] text-white rounded-md h-12 px-8"
      >
        <Mic className="h-5 w-5 mr-2" /> Démarrer l'enregistrement
      </Button>
    )}
    {recState === "recording" && (
      <>
        <Button data-testid="pause-recording-btn" onClick={onPause}
          variant="outline" className="border-af rounded-md h-12 px-6">
          <Pause className="h-5 w-5 mr-2" /> Pause
        </Button>
        <Button data-testid="stop-recording-btn" onClick={onStop}
          className="bg-forest hover:bg-[#2B1F12] text-white rounded-md h-12 px-6">
          <Square className="h-5 w-5 mr-2" /> Arrêter & transcrire
        </Button>
      </>
    )}
    {recState === "paused" && (
      <>
        <Button data-testid="resume-recording-btn" onClick={onResume}
          className="bg-terracotta hover:bg-[#9C7124] text-white rounded-md h-12 px-6">
          <Play className="h-5 w-5 mr-2" /> Reprendre
        </Button>
        <Button data-testid="stop-recording-btn" onClick={onStop}
          className="bg-forest hover:bg-[#2B1F12] text-white rounded-md h-12 px-6">
          <Square className="h-5 w-5 mr-2" /> Arrêter & transcrire
        </Button>
      </>
    )}
    {recState === "failed" && (
      <>
        <Button data-testid="retry-processing-btn" onClick={onRetry}
          className="bg-terracotta hover:bg-[#9C7124] text-white rounded-md h-12 px-6">
          <RefreshCw className="h-4 w-4 mr-2" /> Réessayer le traitement
        </Button>
        <Button data-testid="restart-btn" onClick={onRestart}
          variant="outline" className="border-af rounded-md h-12 px-5">
          <RotateCcw className="h-4 w-4 mr-2" /> Réenregistrer
        </Button>
      </>
    )}
    {recState === "done" && (
      <>
        <Button data-testid="restart-btn" onClick={onRestart}
          variant="outline" className="border-af rounded-md h-12 px-5">
          <RotateCcw className="h-4 w-4 mr-2" /> Recommencer
        </Button>
        <Button data-testid="open-meeting-btn" onClick={onOpenMeeting}
          className="bg-terracotta hover:bg-[#9C7124] text-white rounded-md h-12 px-6">
          <ExternalLink className="h-5 w-5 mr-2" /> Ouvrir la réunion
        </Button>
      </>
    )}
  </div>
);
